import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';


function formatDate(dateString) {
    const date = new Date(dateString);
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
  
    return `${formattedDate}`;
  }


  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return `${formattedTime}`;
  }

export default function RemarksDialog(props) {


    return (
        <React.Fragment>
           
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'>Remarks</Typography>

                    <Box sx={{ position: 'absolute', top: 5, right: 5, cursor: 'pointer', fontSize: '22px' }} onClick={props.handleClose}>
                        <IoClose />

                    </Box>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <table>
                        {
                                props.data && props.data.remarks?
                                props.data.remarks.map((item,index)=>(
                                    <tr key={index}>
                                        <th style={{textAlign:"left"}}>{item.updated_by.user_name}</th>
                                        <td>:</td>
                                        <td>{item[`${index+1}_remarks`]}</td>
                                        <td>:</td>
                                        <td>{formatDate(item.updated_at)} / {formatTime(item.updated_at)}</td>
                                    </tr>
                                ))
                                :
                                <tr>No remarks found</tr>
                            }
                        </table>

                    </DialogContentText>
                </DialogContent>

            </Dialog>
        </React.Fragment>
    );
}
